import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Cookies from 'js-cookie'; //引入cookie操作依赖

Vue.use(Router)

const routes = [

  {
    path: '/login',
    name: 'Login',
    component: resolve => require(['../components/Login/Login'], resolve),
  },

  /*{
    path: '/home',
    redirect: '/index',
    component: resolve => require(['../components/Index/Index'], resolve),
    children: []
  },*/

  {
    path: '/home',
    name: 'home',
    redirect: '/index',
    component: resolve => require(['../components/Home/Home'], resolve),
    children: [
      {
        path: '/index',
        name: 'index',
        component: resolve => require(['../components/Index/Index'], resolve),
      },
      {
        path: '/scheme',
        name: 'scheme',
        component: resolve => require(['../components/Scheme/Scheme'], resolve),
      },
      {
        path: '/product',
        name: 'Product',
        component: resolve => require(['../components/Product/Product'], resolve),
      },
      {
        path: '/interpret',
        name: 'Interpret',
        component: resolve => require(['../components/Interpret/Interpret'], resolve),
      },
      {
        path: '/about',
        name: 'About',
        component: resolve => require(['../components/AboutUs/About'], resolve),
      },
      {
        path: '/chat',
        name: 'Chat',
        component: resolve => require(['../components/Chat/Chat'], resolve),
      },
    ]
  },

  {
    path: '/',
    redirect: '/home',
    component: resolve => require(['../components/Home/Home'], resolve),
    children: []
  },

]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: routes
})
const router = createRouter()

router.beforeEach((to, from, next) => {
  // 判断路由是否去登录界面
  NProgress.start();//路由动画
  return next()
  // if (to.path === '/login'){
  //   return next()
  // }else {
  //   const tokenFlag = Cookies.get('aipeopletoken')
  //   if (!tokenFlag){
  //     return next('/index')
  //   }else{
  //     return next()
  //   }
  //
  // }

})
//路由后置钩子，路由结束动画
router.afterEach(() => {
  NProgress.done()
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js